/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_REVIEW_URL, COMMON_HEADER_CONFIG} from "../config";

class ReviewService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchReviews = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_REVIEW_URL}/reviews`,
        params: {
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getList = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_REVIEW_URL}/reviews`,
        params: {
          size: 100,
          page: 1,
          sort: "created_at DESC"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOne = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_REVIEW_URL}/review/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  update = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "PATCH",
        url: `${API_REVIEW_URL}/review/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteComment = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "DELETE",
        url: `${API_REVIEW_URL}/review/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: id
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(id);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const reviewService = new ReviewService();

export default reviewService;
